














import Vue from "vue"
import MaterialIcon, {
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    isFavorited: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      // ページ描画時にアニメーションが走らないように最初のクリックタイミングでアニメーションを有効にしている。
      isActiveAnimation: false,
    }
  },
  computed: {
    iconType() {
      return { FILLED }
    },
  },
  methods: {
    handleClick() {
      this.isActiveAnimation = true
      this.$emit("click")
    },
  },
})
